// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__157VO","footer":"ChangeClinic_footer__nBVf7"};